'use strict';

import {Map as IMap, Set as ISet} from 'immutable';
import React, {useState, createContext, useContext} from 'react';
import {isStale, useStaleDataLoader} from "../../react-components/stale-data-hooks";

const DashboardFilterContext = createContext(null);
const InitialFilter = updateFilter(new IMap(), {});

function updateFilter(filter, values) {
	return filter.withMutations(f => {
		for (let [k, v] of Object.entries(values)) {
			let tokens;
			if (!v) {
				f.delete(k);
				continue;
			}
			if (!Array.isArray(v)) {
				v = [v];
			}
			if (v[0] === '*') {
				f.delete(k);
				continue;
			}
			tokens = f.get(k) || new ISet();
			tokens = tokens.intersect(v).union(v);
			f.set(k, tokens);
		}
	});
}

function DashboardFilterProvider({children}) {
	const [filter, setFilter] = useState(InitialFilter);
	return (
		<DashboardFilterContext.Provider value={[filter, setFilter]}>
			{children}
		</DashboardFilterContext.Provider>
	);
}

function useDashboardFilter() {
	return useContext(DashboardFilterContext);
}

export {DashboardFilterProvider, updateFilter, useDashboardFilter, useStaleDataLoader, isStale};